import React, { useEffect, useState } from "react";
import { Row, Col, DatePicker, Table, Card, Divider } from "antd";
import { apiCall } from "../../shared/helpers/networkHelper";
import moment from "moment";
import ErrorHandler from "../../shared/classes/ErrorHandler";

const { RangePicker } = DatePicker;

const genderColumns = [
    {
        title: "Gender",
        dataIndex: "user_gender",
        key: "user_gender",
        render: user_gender => (user_gender === 1 ? "Laki-laki" : "Perempuan")
    },
    { title: "Jumlah Pasien", dataIndex: "patient_count", key: "patient_count" }
];
const horizontalColumns = [
    { title: "Pria", dataIndex: "pria", key: "pria" },
    { title: "Wanita", dataIndex: "wanita", key: "wanita" }
];
const pageTitle = "Report Statistik RME - Gender Pasien";

export default function PatientGender() {
    const [dates, setDates] = useState([]);
    const [genderData, setGenderData] = useState([]);

    useEffect(() => {
        apiCall(
            `cashier/emr/statistic/patient-count/by-gender?start_date=${moment(
                dates[0]
            ).format("YYYY-MM-DD")}&end_date=${moment(dates[1]).format(
                "YYYY-MM-DD"
            )}`,
            "GET",
            {},
            res => setGenderData(res.data),
            err => ErrorHandler.handleGeneralError(err)
        );
    }, [dates]);

    const transformed = [
        {
            pria: genderData.find(g => g.user_gender === 1)?.patient_count || 0,
            wanita:
                genderData.find(g => g.user_gender !== 1)?.patient_count || 0
        }
    ];

    return (
        <Card title={pageTitle} bordered={false}>
            <Row gutter={16}>
                <Col>
                    <RangePicker value={dates} onChange={setDates} />
                </Col>
            </Row>

            <Divider />

            {/* <Card title="Laporan Gender Pasien"> */}
            <Table
                rowKey="user_gender"
                columns={horizontalColumns}
                dataSource={transformed}
                pagination={false}
                bordered
            />
            {/* </Card> */}
        </Card>
    );
}

